import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToHash } from "@/lib/scroll";

const LINKS = [
  { label: "Menu", hash: "#prices", testId: "nav-link-prices" },
  { label: "Price Calculator", hash: "#calculator", testId: "nav-link-calculator" },
  { label: "Gallery", hash: "#gallery", testId: "nav-link-gallery" },
  { label: "Gifts", hash: "#gifts", testId: "nav-link-gifts" },
  { label: "FAQ", hash: "#faq", testId: "nav-link-faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const go = (hash) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: hash } });
    } else {
      scrollToHash(hash);
    }
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed inset-x-0 top-0 z-40 border-b border-[#D4AF37]/20 bg-[#FDFBF7]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 lg:px-10">
        <Link to="/" data-testid="nav-home-link" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={l.testId}
              onClick={() => go(l.hash)}
              className="text-sm tracking-wide text-[#2F4A78] transition-colors duration-300 hover:text-[#D4AF37]"
            >
              {l.label}
            </button>
          ))}
          <Link
            to="/story"
            data-testid="nav-link-story"
            className="text-sm tracking-wide text-[#2F4A78] transition-colors duration-300 hover:text-[#D4AF37]"
          >
            Founder Story
          </Link>
          <button
            data-testid="nav-book-consultation-button"
            onClick={() => go("#enquiry")}
            className="rounded-full border border-[#D4AF37]/60 bg-[#D4AF37]/10 px-6 py-2.5 text-sm font-medium tracking-wide text-[#8A6D1F] transition-all duration-300 hover:bg-[#D4AF37] hover:text-[#1B3A6B]"
          >
            Order Now
          </button>
        </nav>

        <button
          data-testid="nav-mobile-menu-button"
          className="text-[#D4AF37] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-[#D4AF37]/20 bg-[#FDFBF7]/95 px-6 py-6 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <button
                key={l.hash}
                data-testid={`${l.testId}-mobile`}
                onClick={() => go(l.hash)}
                className="text-left text-base text-[#2F4A78] transition-colors hover:text-[#D4AF37]"
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/story"
              data-testid="nav-link-story-mobile"
              onClick={() => setOpen(false)}
              className="text-base text-[#2F4A78] transition-colors hover:text-[#D4AF37]"
            >
              Founder Story
            </Link>
            <button
              data-testid="nav-book-consultation-button-mobile"
              onClick={() => go("#enquiry")}
              className="mt-2 rounded-full border border-[#D4AF37]/60 bg-[#D4AF37] px-6 py-3 text-sm font-medium text-[#1B3A6B]"
            >
              Order Now
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
